<template>
  <section id="conventionalTrackingRequest" class="page-content">
    <header id="section-header">
      <p class="title has-text-grey">Tracking request form</p>
      <p class="subtitle has-text-grey">Create a new tracking request.</p>
    </header>
    <main id="section-body">
      <div class="field">
        <label class="label">Vessel *</label>
        <div class="control">
            <input type="text" class="input" v-model="trackingRequest.vessel_imo" style="width:20%" required=true/>
          </div>
      </div>
      <div class="container-stages">
        <label class="label">Stages</label>
        <div class="wrapper">
          <div :class="'step origin'">
            <span class="flag-wrapper">
              <span :class="'ico-wrapper anchor'">
                <icon icoClass="flag-event-ico" selected='anchor'/>
              </span>
            </span>
            <div class="mini-title">Port of Loading</div><br />
            <div class="bold-title dates">
              <div class="date-group">
                <span class="date-wrapper discharge">
                    <div class="date-title">PORT</div>
                    <div class="control">
                      <search-combo url="ports" field="name" field2="locode" inputClass="input" searchField="search" @data="trackingRequest.pol.port=$event?$event.id:undefined" :source="trackingRequest.pol.port"></search-combo>
                    </div>
                </span>
              </div>
            </div>
            <div class="bold-title dates">
              <div class="date-group">
                <span class="date-wrapper discharge">
                    <div class="date-title">DEPARTURE PLANNED</div>
                    <datepicker
                      :inputClass="'input'"
                      :format="'yyyy-MM-dd'"
                      :placeholder="'YYYY-MM-DD'"
                      :monday-first=true
                      :typeable=true
                      :clear-button=true
                      :clear-button-icon="'fa fa-times'"
                      v-model="trackingRequest.pol.departure_planned"
                    />
                </span>
              </div>
            </div>
          </div>
          <div style="position:relative">
            <button class="button-plus" @click="addStageIndex(0)">
              <icon icoClass="flag-event-ico" selected='add'/>
            </button>
          </div>
          <div :class="'step transhipment'" v-for="(stage, index) in stages" :key="index">
            <div>
              <button class="button-delete" @click="deleteStage(index)">
                <icon icoClass="flag-event-ico" selected='delete'/>
              </button>
            </div>
            <span class="flag-wrapper">
              <span :class="'ico-wrapper'">
                <icon icoClass="flag-event-ico" selected='transhipment'/>
              </span>
            </span>
            <div class="mini-title">Transhipment</div><br />
            <div class="bold-title dates">
              <div class="date-group">
                <span class="date-wrapper discharge">
                    <div class="date-title">PORT</div>
                    <div class="control">
                      <search-combo url="ports" field="name" field2="locode" inputClass="input" searchField="search" @data="stage.port=$event?$event.id:undefined" :source="stage.port"></search-combo>
                    </div>
                </span>
              </div>
            </div>
            <div class="bold-title dates">
              <div class="date-group">
                <span class="date-wrapper arrival">
                    <div class="date-title">ARRIVAL PLANNED</div>
                    <datepicker
                      :inputClass="'input'"
                      :format="'yyyy-MM-dd'"
                      :placeholder="'YYYY-MM-DD'"
                      :monday-first=true
                      :typeable=true
                      :clear-button=true
                      :clear-button-icon="'fa fa-times'"
                      v-model="stage.arrival_planned"
                    />
                </span>
                <span class="date-wrapper discharge">
                  <div class="date-title">DEPARTURE PLANNED</div>
                  <datepicker
                    :inputClass="'input'"
                    :format="'yyyy-MM-dd'"
                    :placeholder="'YYYY-MM-DD'"
                    :monday-first=true
                    :typeable=true
                    :clear-button=true
                    :clear-button-icon="'fa fa-times'"
                    v-model="stage.departure_planned"
                  />
                </span>
              </div>
            </div>
            <div style="position:relative">
              <button class="button-plus" @click="addStageIndex(index+1)" style="margin-top: -8em;margin-left: 6.8em;">
                <icon icoClass="flag-event-ico" selected='add'/>
              </button>
            </div>
          </div>
          <div :class="'step origin'">
            <span class="flag-wrapper">
              <span :class="'ico-wrapper anchor'">
                <icon icoClass="flag-event-ico" selected='anchor'/>
              </span>
            </span>
            <div class="mini-title">Port of Discharge</div>
            <br />
            <div class="bold-title dates">
              <div class="date-group">
                <span class="date-wrapper discharge">
                    <div class="date-title">PORT</div>
                    <div class="control">
                      <search-combo url="ports" field="name" field2="locode" inputClass="input" searchField="search" @data="trackingRequest.pod.port=$event?$event.id:undefined" :source="trackingRequest.pod.port"></search-combo>
                    </div>
                </span>
              </div>
            </div>
            <div class="bold-title dates">
              <div class="date-group">
                <span class="date-wrapper arrival">
                    <div class="date-title">ARRIVAL PLANNED</div>
                    <datepicker
                      :inputClass="'input'"
                      :format="'yyyy-MM-dd'"
                      :placeholder="'YYYY-MM-DD'"
                      :monday-first=true
                      :typeable=true
                      :clear-button=true
                      :clear-button-icon="'fa fa-times'"
                      v-model="trackingRequest.pod.arrival_planned"
                    />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a class="button is-primary" @click="save()" :disabled="saving">Save</a>
      <router-link :to="{ name: 'shipment-conventional-list'}" class="button">Back</router-link>
    </main>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import icon from './../../svg/events'
import SearchCombo from '../../components/SearchCombo.vue'

export default {
  name: 'conventionalTrackingRequestAdd',
  components: {Datepicker, SearchCombo, icon},
  created () {
    this.$emit('loading')
    const promises = [
      this.getPorts().then(response => {
        this.ports = response
      })
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      trackingRequest: {vessel_imo: '', pol: {source: 'manual', type: 'pol'}, pod: {source: 'manual', type: 'pod'}, transhipments: []},
      ports: [],
      isEditingStage: false,
      stages: [],
      saving: false
    }
  },
  computed: {
    ...mapGetters({hasPermission: 'hasPermission'})
  },
  methods: {
    ...mapActions({
      getPorts: 'port/list',
      saveConventionalTrackingRequest: 'conventionalTrackingRequest/save'
    }),
    save () {
      this.saving = true

      this.trackingRequest.transhipments = this.stages

      this.saveConventionalTrackingRequest(this.trackingRequest).then(response => {
        this.trackingRequest = {vessel_imo: '', pol: {source: 'manual', type: 'pol'}, pod: {source: 'manual', type: 'pod'}, transhipments: []}
        this.stages = []
        this.saving = false
        this.$router.push({name: 'conventional-tracking-request-list'})
      })
    },
    addStageIndex (index) {
      if (!this.stages) {
        this.stages = []
      }
      this.stages.splice(index, 0, {source: 'manual', type: 'tsp'})
    },
    deleteStage (index) {
      this.stages.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.flag-wrapper {
  display: inline-block;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  .ico-wrapper{
    line-height: 1em;
    margin-left: 0em;
    z-index: 200;
    position: relative;
    box-shadow: -.1em .1em .2em rgba($color: #000000, $alpha: .5);
  }
}
.dates {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
}
.date-group{
  flex: 1;
  display: flex;
  flex-direction: column;
}
.date-wrapper {
  margin: .3em;
  flex:1;
}
.date-title {
  font-size: .7em;
  font-family: MuseoSans-900;
  color: gray;
  white-space: nowrap;
}
.date {
  font-size: .85em;
  margin-top: .5em;
  white-space: nowrap;
}
#status-calendar{
  position: relative;
}
#full {
  background: rgb(48, 177, 65);
}
#empty {
  background: white;
}

.wrapper {
  display: flex;
  min-width: 70%;
  border: 1px solid lightgray;
  padding: 1.5em;
  border-radius: 10px;
  margin-bottom: 1.5em;
}
.step{
  margin: 0 .5em 0em .5em;
  background: white;
  border: 1px solid lightgray;
  border-radius: 10px;
  min-height: 280px;
  width: 100px;
  flex-grow: 1;
  padding: 1em .3em;
  text-align: center;
  padding-bottom: 2.5em;
  max-width: 15em;
}

.dlv  .ico-wrapper, .origin .ico-wrapper{
  background: #ff7525;
}
.ico-wrapper {
  background: rgb(28, 167, 209);
  display: inline-block;
  border-radius: 50%;
  padding: 5px;
}

.card {
  width: 100%;
  select {
    width: 100%;
  }
}

input {
  border-radius: 7px;
}

.button-plus {
  background: $success;
  height: 2em;
  border-radius: 20px;
  position: absolute;
  margin-top: 10em;
  margin-left: -1em;
  border: none;
  cursor: pointer;
}

.button-plus:hover {
  background: $success-dark;
}

.button-delete {
  background: $danger;
  height: 2em;
  border-radius: 20px;
  position: absolute;
  margin-top: -1.5em;
  margin-left: 6em;
  border: none;
  cursor: pointer;
}
.button-delete:hover {
  background: $danger-dark;
}

@media only screen and (max-width: 1000px) {
  .wrapper {
    flex-direction: column;
  }
  .step{
    flex: 1;
    min-width: 50%;
    padding: 1em .3em;
    text-align: center;
    padding-left: 3.5em;
  }
}
.help-cursor{
  cursor:help;
}
.anchor {
  background: #39bc08!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/conventional/PageConventionalTrackingRequestAdd.vue